import BanksListContainer from 'containers/Banks/BankList'
import React from 'react'

const BankListPage = () => {
  return <BanksListContainer />
}

export default BankListPage
